import * as React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Spin, Layout } from 'antd';
import LayoutSider from '../../components/LayoutSider';

const { Header, Content, Footer } = Layout;

export interface LayoutProps {
  children: React.ReactNode | React.ReactNode[];
}

// Used as the main layout style for most app pages. Includes header, general content area, and footer.
export default function MainLayout(props: LayoutProps) {
  const auth = useSelector((state: any) => state.auth);

  const renderContent = () => {
    switch (auth) {
      // Show spinner while user is being determined
      case null:
        return <Spin />;

      // If empty user, redirect to login
      case '': {
        window.location.href = `/login`;
        return null;
      }

      // If user exists, display layout with current page
      default:
        return (
          <Layout style={{ minHeight: '100vh' }}>
            <LayoutSider />
            <Layout className="site-layout">
              {/* <Header className="site-layout-background" style={{ padding: 0 }} /> */}
              <Content style={{ padding: '2% 6%', backgroundColor: '#fafafa' }}>
                <div className="site-layout-content">{props.children}</div>
              </Content>
              <Footer style={{ textAlign: 'center' }}>©2021</Footer>
            </Layout>
          </Layout>
        );
    }
  };

  return <>{renderContent()}</>;
}

MainLayout.propTypes = {
  children: PropTypes.element.isRequired,
};
